import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../../interfaces/overlayable";

@Component({
  selector: 'brt-ranking-list-overlay-header',
  templateUrl: './ranking-list-overlay-header.component.html',
  styleUrls: ['./ranking-list-overlay-header.component.scss']
})
export class RankingListOverlayHeaderComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

}
